import {ValueObject} from '@s-ui/domain'

export class MakeModelFaqsRequest extends ValueObject {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.query
   * @param {String} param.endpoint
   **/

  static validate({make, model, invalidMakeModelFaqsRequestError}) {
    const hasMake = Boolean(make)
    const hasModel = Boolean(model)

    if (!hasMake || !hasModel) throw invalidMakeModelFaqsRequestError('Make and model are required')
  }
}
